<template >

  <b-nav-item-dropdown class="dropdown-cart mr-25" menu-class="dropdown-menu-media" right>
  <!-- @show="fetchItems" -->
    <template  #button-content>
      <feather-icon @click="getShoppingBasketItems" class="text-body" icon="ShoppingCartIcon" size="21"/>
      <!-- :badge="$store.state['app-ecommerce'].cartItemsCount" -->
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto"> Cesta de la compra </h4>
        <b-badge pill variant="light-primary"> {{ allItems.length }} Items </b-badge>
      </div>
    </li>

    <!-- Cart Items -->
    <vue-perfect-scrollbar v-if="allItems.length" :settings="perfectScrollbarSettings" class="scrollable-container media-list scroll-area" tagname="li">
      <b-media v-for="i in allItems" :key="i.item.name">
        <template #aside>
          <!-- <b-img src="https://images.hola.com/imagenes/mascotas/20201104178485/consejos-gatos-para-principiantes/0-884-859/gatito-m.jpg?tx=w_680" :alt="i.item.name" rounded width="100" /> -->
          <b-img :src="require('@/assets/images/logo/logo.png')" :alt="i.item.name" rounded width="100" class="p-1" />
        </template>
        <feather-icon icon="XIcon" class="cart-item-remove cursor-pointer" @click.stop="removeItem(i.item.id, i.type)"/>
        <div class="media-heading">
          <h6 class="cart-item-title"> {{ i.item.name }} </h6>
          <div class="cart-item-qty">
            <b-form-spinbutton id="i.item.id" v-model="i.quantity" min="1" size="sm" :disabled="i.type=='courses'? true: false" />
          </div>
        </div>
        <h5 class="cart-item-price"> {{ (i.item.total * i.item.quantity).toFixed(2) }}€ </h5>
      </b-media>


    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li v-if="allItems.length" class="dropdown-menu-footer">
      <!-- <div class="d-flex justify-content-between mb-1">
        <h6 class="font-weight-bolder mb-0"> Total: </h6>
        <h6 class="text-primary font-weight-bolder mb-0"> {{ totalAmount.toFixed(2) }}€ </h6>
      </div> -->
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" block :to="{ name: 'checkout' }"> Continuar </b-button>
    </li>

    <p v-if="!allItems.length" class="m-0 p-1 text-center"> No se ha añadido ningún producto al carrito </p>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BBadge, BMedia, BLink, BImg, BFormSpinbutton, BButton } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import courseModule from '../../views/pages/courses/courseModule.js';
import productModule from '../../views/pages/products/productModule.js';
import { ref, watch } from '@vue/composition-api';


export default {
  components: { BNavItemDropdown, BBadge, BMedia, BLink, BImg, BFormSpinbutton, VuePerfectScrollbar, BButton },
  directives: { Ripple },
  data() {
    return {
      items: (null),
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      PRODUCT_MODULE : 'products',
      COURSES_MODULE : 'courses',
      recollido: 0,
      itemsIdType: null,
      newItem:null,
      allItems:[],
      totalPrice:0,
      subtotal:0,
      discounts:0,
      taxableBase:0,
      totalAmount:0,
      vatsInvoice:[],
      pitsInvoice:[],
    }
  },
  methods: {
    // calculateTotalPrice ()  {
    //   this.totalPrice = 0
    //   this.allItems.forEach(a => {
    //     this.totalPrice += parseInt(a.item.quantity) * parseFloat(a.item.amount)
    //   })
    // },
    calculateTotalPrice ()  {
      this.subtotal=0
      this.discounts=0
      this.taxableBase=0
      this.vatsInvoice=[]
      this.pitsInvoice=[]

        let mappedAllItems=this.allItems.map(a=>a.item)
        mappedAllItems.forEach(item => {
          let subtotalItem=parseInt(item.quantity) * parseFloat(item.amount) ;
          let taxableBaseItem= subtotalItem - (parseFloat(item.discount)/100 * subtotalItem)
          this.subtotal += subtotalItem
          this.discounts += parseFloat(item.discount)/100 * subtotalItem
          this.taxableBase=this.subtotal-this.discounts

          // Sumatorio de ivas
          if (item.tax!==null) {
            let newVat=taxableBaseItem * (item.tax.value/100)
            if (this.vatsInvoice.length!=0) {
              let index=this.vatsInvoice.findIndex(vat=>vat==item.tax.value)
              if (index<0) {
                this.vatsInvoice.push({value: item.tax.value, price:newVat})
              } else {
                this.vatsInvoice[index].price+=newVat
              }
            } else {
              this.vatsInvoice.push({value: item.tax.value, price:newVat})
            }
          }

          // Sumatorio irpfs pitsInvoice
          if (item.pit!==undefined && item.pit!==null) {
            let newPit=taxableBaseItem * (item.pit/100)
            if (pitsInvoice.length!=0) {
              let index2=pitsInvoice.findIndex(pit=>pit==item.pit)
              if (index2<0) {
                this.pitsInvoice.push({value: item.pit, price:newPit})
              } else {
                this.pitsInvoice[index2].price+=newPit
              }
            } else {
              this.pitsInvoice.push({value: item.pit, price:newPit})
            }
          }
      })

        let totalVats=0;
        let totalPits=0;

       

        this.vatsInvoice.forEach(v=>totalVats+=v.price)
        this.pitsInvoice.forEach(p=>totalPits+=p.price)

        this.totalAmount=this.taxableBase + totalVats - totalPits
    },
    removeItem(idToDelete, type)  {
        let index=  this.itemsIdType.findIndex(item => item.id==idToDelete && item.type==type)
        this.itemsIdType.splice(index,1)
        if (this.itemsIdType.length==0) {
          localStorage.removeItem("shoppingBasket")
        }
        
        localStorage.setItem("shoppingBasket", JSON.stringify(this.itemsIdType));
        this.getItems()
    },

    getShoppingBasketItems () {
      const shoppingBasket=JSON.parse(localStorage.getItem("shoppingBasket"));

      if (shoppingBasket) {
        this.itemsIdType=[ ...shoppingBasket]
        this.getItems()
      }
      },

    getItems(){

      this.allItems=[];
      if (this.itemsIdType!=null) {

        for (const item of this.itemsIdType) {

          if (item.type=="courses") {
            store.dispatch('courses/fetchCourse', {id: item.id}).then(response => {
              this.newItem=response.data.course
              this.newItem.quantity=item.quantity
              this.newItem.tax=this.newItem.tax
              this.newItem.discount=0
              this.allItems.push({item: this.newItem, type:"courses",quantity: item.quantity})
              this.calculateTotalPrice()
          })
          } else if (item.type=="products") {
              store.dispatch('products/fetchProduct', {id: item.id}).then(response => {
                  this.newItem=response.data.product;
                  this.newItem.quantity=item.quantity;
                  this.newItem.discount=0
                  this.allItems.push({item: this.newItem, type:"products",quantity: item.quantity})
                  this.calculateTotalPrice()
              })
          }
        }
      }
    }
  },

  watch: {
    allItems: {
      deep:true,
      handler( newValue) {
        if (this.recollido==0 || (this.allItems.length==this.itemsIdType.length && this.recollido>this.itemsIdType.length) ) {
          for (let n of newValue) {
              let index= this.itemsIdType.findIndex(i=> (i.id==n.item.id && i.type==n.type ))
              this.itemsIdType[index].quantity=n.quantity
              let index2=this.allItems.findIndex(a=> (a.item.id==n.item.id && a.type==n.type ))
              this.allItems[index2].item.quantity=n.quantity
              this.allItems[index2].item.quantity
            }
          localStorage.setItem("shoppingBasket", JSON.stringify(this.itemsIdType));
          this.calculateTotalPrice()
        }
        this.recollido++
      }
    }

  },
  created() {
    if(!store.hasModule(this.PRODUCT_MODULE)) store.registerModule(this.PRODUCT_MODULE, productModule)
    if(!store.hasModule(this.COURSES_MODULE)) store.registerModule(this.COURSES_MODULE, courseModule)
  },
  onUnmounted() {
    if(store.hasModule(this.PRODUCT_MODULE)) store.registerModule(this.PRODUCT_MODULE)
    if(store.hasModule(this.COURSES_MODULE)) store.registerModule(this.COURSES_MODULE)
  }


}

</script>

<style lang="scss" scoped>
.dropdown-cart {
  .media {
    .media-aside {
      align-items: center;
    }
  }
}
</style>
